import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { watch } from 'vue';
import { ref } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'ConfirmDialog',
  props: {
    title: null,
    message: null,
    isDialogOpen: { type: Boolean },
    type: null
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'confirm'): void;
  (e: 'cancel'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  title: string;
  message: string;
  isDialogOpen: boolean;
  type: string;
};



const showDialog = ref(false);


const onCancel = () => {
  emit('cancel');
};

const onConfirm = () => {
  emit('confirm');
};

// props.isDialogOpenの値が変更されたら、showDialogの値も変更する
watch(() => props.isDialogOpen, (value) => {
  showDialog.value = value;
});

watch(() => showDialog, (showDialog) => {
  console.log(showDialog.value);
});

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showDialog).value = $event)),
    "min-width": "240",
    "max-width": __props.type === 'source' ? '70%': '480',
    persistent: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "text-h5" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.title), 1)
            ]),
            _: 1
          }),
          (__props.type === 'confirm')
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.message), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (__props.type === 'source')
            ? (_openBlock(), _createBlock(_component_v_card_text, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    variant: "outlined",
                    "model-value": __props.message,
                    rows: "20",
                    style: {"overflow-y":"auto"},
                    readonly: ""
                  }, null, 8, ["model-value"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                color: "green darken-1",
                text: "",
                onClick: onConfirm
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.type === 'confirm' ? 'はい': '閉じる'), 1)
                ]),
                _: 1
              }),
              (__props.type === 'confirm')
                ? (_openBlock(), _createBlock(_component_v_btn, {
                    key: 0,
                    color: "green darken-1",
                    text: "",
                    onClick: onCancel
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("いいえ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "max-width"]))
}
}

})